module.exports = __webpack_public_path__ + "img/background.d7e31566.png";